import React from 'react';
import { useNavigate } from 'react-router-dom';
import splashMovie from '../assets/logo-1080-a.mp4';

const REDIRECT_FALLBACK_MS = 3500;

type LaunchSplashScreenProps = {
  onShown?: () => void;
};

const LaunchSplashScreen: React.FC<LaunchSplashScreenProps> = ({ onShown }) => {
  const navigate = useNavigate();
  const hasNavigatedRef = React.useRef(false);
  const hasMarkedShownRef = React.useRef(false);

  const continueToApp = React.useCallback(() => {
    if (hasNavigatedRef.current) {
      return;
    }
    hasNavigatedRef.current = true;
    navigate('/reserve', { replace: true });
  }, [navigate]);

  React.useEffect(() => {
    const redirectTimer = window.setTimeout(() => {
      continueToApp();
    }, REDIRECT_FALLBACK_MS);

    return () => {
      window.clearTimeout(redirectTimer);
    };
  }, [continueToApp]);

  const handleVideoStarted = React.useCallback(() => {
    if (hasMarkedShownRef.current) {
      return;
    }
    hasMarkedShownRef.current = true;
    onShown?.();
  }, [onShown]);

  return (
    <div className="relative flex min-h-[100svh] items-center justify-center overflow-hidden bg-white">
      <video
        className="block w-[78vw] max-w-[396px] max-h-[86svh] object-contain"
        autoPlay
        muted
        playsInline
        preload="auto"
        onPlay={handleVideoStarted}
        onLoadedData={handleVideoStarted}
        onEnded={continueToApp}
        onError={continueToApp}
      >
        <source src={splashMovie} type="video/mp4" />
      </video>
    </div>
  );
};

export default LaunchSplashScreen;
